import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc9b4f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","flex-direction":"column","align-items":"center","margin-bottom":"-5rem"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " It's a Match ", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "productChoices" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 2,
  style: {"margin-top":"5em"}
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "products" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeedbackStars = _resolveComponent("FeedbackStars")!
  const _component_ProductCardV2 = _resolveComponent("ProductCardV2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.company.CompanyQuizConfig.showPartnerMatching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["container", { homepageMode: _ctx.company.homepageMode }])
    }, [
      (!_ctx.company.CompanyQuizConfig.DisableFeedbackQuestion &&
			(_ctx.innerWidth > 850 ||
				!_ctx.company.CompanyQuizConfig.DisableFeedbackQuestionOnMobile)
			)
        ? (_openBlock(), _createBlock(_component_FeedbackStars, {
            key: 0,
            questionId: _ctx.company.Quiz.getCurrentQuestion().Id,
            baseComponentTranslations: _ctx.baseComponentTranslations,
            visible: _ctx.showFeedbackQuestion,
            company: _ctx.company
          }, null, 8, ["questionId", "baseComponentTranslations", "visible", "company"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.company.Quiz.getCurrentQuestion().Headline && !_ctx.company.Quiz.getCurrentQuestion().HtmlTemplate)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_5, [
              _createTextVNode(" It's a Match. "),
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.headline), 1)
            ]))
          : (!_ctx.company.Quiz.getCurrentQuestion().HtmlTemplate)
            ? (_openBlock(), _createElementBlock("h2", {
                key: 1,
                innerHTML: _ctx.company.Quiz.getCurrentQuestion().Headline
              }, null, 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8)),
        (_ctx.company.Quiz.getCurrentQuestion().HtmlTemplate)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              innerHTML: _ctx.company.Quiz.getCurrentQuestion().HtmlTemplate
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.Match ? _ctx.filteredProductList?.slice(0, 3) : [], (product, index) => {
            return (_openBlock(), _createBlock(_component_ProductCardV2, {
              key: product.Name,
              product: product,
              company: _ctx.company,
              onProductImageClicked: ($event: any) => (_ctx.onProductImageClicked(product)),
              onProductClicked: ($event: any) => (_ctx.onProductClicked(product)),
              onProductFeedbackCauseSelected: _ctx.onProductFeedbackCauseSelected,
              "is-card-flipped": _ctx.firstV2CardFlipped && index === 0
            }, null, 8, ["product", "company", "onProductImageClicked", "onProductClicked", "onProductFeedbackCauseSelected", "is-card-flipped"]))
          }), 128))
        ])
      ]),
      (_ctx.company.Quiz.getCurrentQuestion().HtmlTemplateAfter)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            innerHTML: _ctx.company.Quiz.getCurrentQuestion().HtmlTemplateAfter
          }, null, 8, _hoisted_11))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}